var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pages"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.currentPage,"page-size":_vm.pageSize,"page-sizes":_vm.pageSizes,"layout":_vm.pageLayout,"total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }